import type { AccountRole } from "@um/contracts";

/** Display label for account role in UI (e.g. "Full access" / "Limited access"). */
export function getAccountRoleDisplayName(role: AccountRole): string {
  return role === "owner" ? "Full access" : "Limited access";
}
